import React, { Fragment, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {
  DateFilter,
  ShipmentFilters,
  ShipperFilter,
  MunicipalityFilter,
  RouteFilter,
  CarrierDriverFilter,
  AlertsFilter,
  HandledByFilter,
  VehicleTypeFilter,
  BusinessFilter,
  BusinessFilterTenant,
  FTBFilter,
} from 'components/ShipmentFilters';

import {
  jobsMounted,
  jobsUnmounted,
  fetchMoreJourneys,
  visibilityChange,
} from 'redux/modules/journeys/effects';

import { filterJobs } from 'redux/modules/jobs/effects';

import { getAssignedFilters } from 'redux/modules/jobs/selectors';

import { AssignedJourneyList } from 'modules/journey/list';

import JobSelector from './JobSelector';
import { constants, getClientConfig } from 'redux/modules/client-config/selectors';

const defaultTitle = 'Jobs';

const Assigned = ({ history, parentRoutes }) => {
  const { location } = history;

  const state = location.state || {};

  const { fromDetail = false } = state;

  const { action } = history;

  const filters = useSelector(getAssignedFilters);
  const dispatch = useDispatch();

  const handleFetchMore = useCallback(
    (params) => {
      dispatch(fetchMoreJourneys(params));
    },
    [dispatch]
  );

  const handleVisibilityChange = useCallback(() => {
    dispatch(visibilityChange(!document.hidden, filters));
  }, [dispatch, filters]);

  const onChangeFilter = useCallback(
    (params) => {
      dispatch(filterJobs(params, { section: 'ASSIGNED' }));
    },
    [dispatch]
  );

  useEffect(() => {
    const triggerFetch = !fromDetail || action === 'POP';
    dispatch(jobsMounted());
    dispatch(filterJobs(filters, { triggerFetch, realtime: true, section: 'ASSIGNED' }));

    return () => {
      dispatch(jobsUnmounted());
    };
    //eslint-disable-next-line
  }, [dispatch]);

  useEffect(() => {
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [handleVisibilityChange]);

  useEffect(() => {
    if (filters.carrier) {
      document.title = filters.carrier.name;
    } else {
      document.title = defaultTitle;
    }

    return () => {
      document.title = defaultTitle;
    };
  }, [filters.carrier]);

  const FILTERS = useSelector((state) => getClientConfig(state, constants.FILTERS));

  return (
    <Fragment>
      <ShipmentFilters
        status={filters}
        onChangeFilter={onChangeFilter}
        rows={[
          [
            <JobSelector routes={parentRoutes} />,
            <DateFilter showCalendar={false} grow />,
            !FILTERS[constants.JOBS_BUSINESS] ? <BusinessFilterTenant marginRight /> : <></>,
            FILTERS[constants.JOBS_BUSINESS] ? <BusinessFilter marginRight /> : <></>,
            FILTERS[constants.JOBS_FTB] ? <FTBFilter /> : <></>,
            <CarrierDriverFilter />,
            <ShipperFilter />,
          ],
          [
            <AlertsFilter />,
            <RouteFilter />,
            FILTERS[constants.JOBS_MUNICIPALITY] ? <MunicipalityFilter grow /> : <></>,
            <HandledByFilter />,
            FILTERS[constants.JOBS_VEHICLE_TYPE] ? <VehicleTypeFilter /> : <></>,
          ],
        ]}
      />
      <AssignedJourneyList onLoadMore={handleFetchMore} />
    </Fragment>
  );
};
export default Assigned;
